import { Dispatch, SetStateAction } from 'react';
import { useIntl } from 'react-intl';
import { Header, HeaderProps } from '@rossum/components/header/Header';
import SearchInput from '@rossum/components/search-input/SearchInput';
import { Typography } from '@rossum/ui/material';
import { HeaderTabs } from '../../components/NavBar/HeaderTabs';
import { tabs } from '../../components/NavBar/navigationStructure';
import { AUTOMATION_DATA_CAPTURE_LINK } from '../../constants/values';
import { link } from '../../lib/formaterValues';

type Props = {
  searchValue: string;
  setSearchValue: Dispatch<SetStateAction<string>>;
} & Pick<HeaderProps, 'scrollableDivRef'>;

export const AutomationHeader = ({
  searchValue,
  setSearchValue,
  ...params
}: Props) => {
  const intl = useIntl();

  return (
    <Header
      {...params}
      title={intl.formatMessage({
        id: 'containers.settings.automation.header.title',
      })}
      description={
        <Typography variant="body2" color="text.secondary">
          {intl.formatMessage(
            {
              id: 'containers.settings.automation.header.description',
            },
            {
              link: link(AUTOMATION_DATA_CAPTURE_LINK),
            }
          )}
        </Typography>
      }
      breadcrumbs={null}
      tabs={
        <HeaderTabs
          menuItems={tabs.find(tab => tab.name === 'automation')?.menu ?? []}
          value="automationSettings"
        />
      }
      buttons={[
        <SearchInput
          key="search-input"
          value={searchValue}
          onChange={value => setSearchValue(value)}
        />,
      ]}
    />
  );
};
